function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { Placement } from 'common/components/tooltip/types';
import { Segmentation } from 'common/types/reports/query';
import { SCDOptionsType } from 'common/widgets/property-filter-menu/models/types';
import { SegmentValue } from 'common/query-builder/query-block/segment-menu/types';
import { ButtonSize } from 'common/components/button/constants';
import { ChangeEvent } from 'common/components/select/types';
import type { Section } from 'common/components/items-menu/types';
import timelineLatestSvg from './timeline-latest.svg';
import timelineAllSvg from './timeline-all.svg';
export function getSCDOptionsTypeSections(scdOptions: Segmentation[`scdOptions`], _ref: {
  aliasLatestAsMostRecent: boolean;
}): Section[] {
  let {
    aliasLatestAsMostRecent
  }: {
    aliasLatestAsMostRecent: boolean;
  } = _ref;
  if (aliasLatestAsMostRecent) {
    return [{
      items: [{
        label: _ref2 => {
          let {
            t
          } = _ref2;
          return t("filters.scd-options-type.fixed");
        },
        value: SCDOptionsType.Latest,
        isSelected: (scdOptions === null || scdOptions === void 0 ? void 0 : scdOptions.type) === SCDOptionsType.Latest || !(scdOptions !== null && scdOptions !== void 0 && scdOptions.type)
      }, {
        label: _ref3 => {
          let {
            t
          } = _ref3;
          return t("filters.scd-options-type.any");
        },
        value: SCDOptionsType.Any,
        tooltip: {
          text: _ref4 => {
            let {
              t
            } = _ref4;
            return t("filters.scd-options-type.tooltip.any");
          },
          'image-src': timelineAllSvg,
          'max-width': "140px"
        },
        isSelected: (scdOptions === null || scdOptions === void 0 ? void 0 : scdOptions.type) === SCDOptionsType.Any
      }]
    }];
  }
  return [{
    items: [{
      label: _ref5 => {
        let {
          t
        } = _ref5;
        return t("filters.scd-options-type.latest");
      },
      value: SCDOptionsType.Latest,
      tooltip: {
        text: _ref6 => {
          let {
            t
          } = _ref6;
          return t("filters.scd-options-type.tooltip.latest");
        },
        'image-src': timelineLatestSvg,
        'max-width': "140px"
      },
      isSelected: (scdOptions === null || scdOptions === void 0 ? void 0 : scdOptions.type) === SCDOptionsType.Latest || !(scdOptions !== null && scdOptions !== void 0 && scdOptions.type) // latest is the default
    }, {
      label: _ref7 => {
        let {
          t
        } = _ref7;
        return t("filters.scd-options-type.any");
      },
      value: SCDOptionsType.Any,
      tooltip: {
        text: _ref8 => {
          let {
            t
          } = _ref8;
          return t("filters.scd-options-type.tooltip.any");
        },
        'image-src': timelineAllSvg,
        'max-width': "140px"
      },
      isSelected: (scdOptions === null || scdOptions === void 0 ? void 0 : scdOptions.type) === SCDOptionsType.Any
    }, {
      label: _ref9 => {
        let {
          t
        } = _ref9;
        return t("filters.scd-options-type.fixed");
      },
      value: SCDOptionsType.Fixed,
      isSelected: (scdOptions === null || scdOptions === void 0 ? void 0 : scdOptions.type) === SCDOptionsType.Fixed
    }]
  }];
}
export function SegmentSCDOptionsSelector(props: {
  hasNewUI: boolean;
  readonly?: boolean;
  segment: Segmentation;
  onSelect?: (value: SegmentValue) => void;
}) {
  return <div className='mp-query-sub-selector' data-sentry-component="SegmentSCDOptionsSelector" data-sentry-source-file="index.tsx">
      <SelectReact className='subitem-select' elref='segmentScdOptionsSelector' menuWidth={200} alwaysShowCaret={props.hasNewUI} theme={SelectTheme.QbSubitem} size={ButtonSize.Small} tooltip={{
      placement: Placement.Top
    }} readonly={props.readonly} sections={getSCDOptionsTypeSections(props.segment.scdOptions, {
      aliasLatestAsMostRecent: false
    })} onChange={((_ref10: ChangeEvent<SCDOptionsType | undefined>) => {
      var _props$onSelect, _props$segment;
      let {
        detail
      }: ChangeEvent<SCDOptionsType | undefined> = _ref10;
      (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 || _props$onSelect.call(props, _objectSpread(_objectSpread({}, props.segment), {}, {
        scdOptions: _objectSpread(_objectSpread({}, (_props$segment = props.segment) === null || _props$segment === void 0 ? void 0 : _props$segment.scdOptions), {}, {
          type: detail.item.value
        })
      }));
    }) as any} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx" />
    </div>;
}